import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import SurveyEditor from "./pages/SurveyEditor";
import SurveyAnalytics from "./pages/SurveyAnalytics";
import PublicSurvey from "./pages/PublicSurvey";
import Help from "./pages/Help";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/survey/:surveyId" element={<PublicSurvey />} />
            
            {/* Protected admin routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/surveys/new" element={
              <ProtectedRoute>
                <SurveyEditor />
              </ProtectedRoute>
            } />
            <Route path="/admin/surveys/:surveyId/edit" element={
              <ProtectedRoute>
                <SurveyEditor />
              </ProtectedRoute>
            } />
            <Route path="/admin/surveys/:surveyId/analytics" element={
              <ProtectedRoute>
                <SurveyAnalytics />
              </ProtectedRoute>
            } />
            <Route path="/admin/help" element={
              <ProtectedRoute>
                <Help />
              </ProtectedRoute>
            } />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
